export const obtenerPorcentajeDescuento = (total, valor) => {

    let num = total * 100 / valor

    let res = 100 - num

    return res.toFixed(0)
}